import { getSearchParamFlag } from '../utils/searchParams';

let withUserState = false;
let autoSaveInterval: undefined | number;

export const userStateTest = getSearchParamFlag('VASDK_USERSTATE') ?? false;

if (userStateTest) {
  withUserState = true;
}

/**
 * Sets whether or not to fetch server user state when subscribing to the report.
 */
export function setWithUserState(value: boolean) {
  withUserState = value;
}

export function getWithUserState() {
  return withUserState;
}

export function setAutoSaveIntervalInSeconds(value: undefined | number) {
  autoSaveInterval = value;
}

export function getAutoSaveIntervalInSeconds() {
  return autoSaveInterval;
}
